import { PERMISSIONS } from '@savgroup-front-common/constants';

import { useCurrentUser } from '../domains/login/useLoginStore';

import { useIsSuperAdmin } from './useHasRole';

export const useActivePermissions = (): PERMISSIONS[] => {
  const { permissions } = useCurrentUser();

  return permissions;
};

const hasPermission = (
  permissions: PERMISSIONS[],
  neededPermission: PERMISSIONS,
): boolean => permissions.includes(neededPermission);

export function useHasPermission(permission: PERMISSIONS): boolean {
  const activePermissions = useActivePermissions();
  const isSuperAdmin = useIsSuperAdmin();

  return hasPermission(activePermissions, permission) || isSuperAdmin;
}

export function useHasEveryPermissions(permissions: PERMISSIONS[]): boolean {
  const activePermissions = useActivePermissions();
  const isSuperAdmin = useIsSuperAdmin();

  return permissions.every(
    (permission) =>
      hasPermission(activePermissions, permission) || isSuperAdmin,
  );
}

export function useHasSomePermissions(permissions: PERMISSIONS[]): boolean {
  const activePermissions = useActivePermissions();
  const isSuperAdmin = useIsSuperAdmin();

  return permissions.some(
    (permission) =>
      hasPermission(activePermissions, permission) || isSuperAdmin,
  );
}

export function hasSomePermissions(
  activePermissions: PERMISSIONS[],
  permissions: PERMISSIONS[],
): boolean {
  return permissions.some((permission) =>
    hasPermission(activePermissions, permission),
  );
}
